// Remove underline from tag label
export const formatTag = (tag) => {
  if (typeof tag !== 'string') return '';
  return tag.replace(/_/g, ' ').toUpperCase();
};
